// ***完整***
import axios from "axios";
import { Toast } from 'vant';
import router from '../router';

export function request(config) {
  const instance = axios.create({
    baseURL: window.config.api,
    timeout: 120000
  });
  //request 请求成功和失败
  instance.interceptors.request.use(
    config => {
      // 为所有请求添加 timestamp 请求头
      config.headers['timestamp'] = Date.now().toString();
      
      // 自动添加token到请求头
      const token = localStorage.getItem('rtc_token') || localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['token'] = token;
      }
      
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  //response 响应成功和失败
  instance.interceptors.response.use(
    response => {
      // 检查响应数据中的code
      const res = response.data;
      if (res && res.code === 401) {
        // 登录过期处理
        Toast.fail('登录信息已过期，请重新登录');
        // 清除登录信息
        localStorage.removeItem('rtc_token');
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('nickName');
        localStorage.removeItem('userName');
        localStorage.removeItem('phonenumber');
        localStorage.removeItem('isLogin');
        localStorage.removeItem('timeStamp');
        // 延迟跳转到登录页
        setTimeout(() => {
          router.push('/login');
        }, 1500);
        return Promise.reject(new Error(res.msg || '登录已过期'));
      }
      return response;
    },
    err => {
      if (err.response && err.response.status) {
        const status = err.response.status;
        const data = err.response.data;
        
        // HTTP状态码对应的中文提示
        const statusMessages = {
          400: '请求参数错误',
          401: '登录信息已过期，请重新登录',
          403: '没有访问权限',
          404: '请求的资源不存在',
          405: '请求方法不允许',
          408: '请求超时',
          500: '服务器内部错误',
          501: '服务器不支持该功能',
          502: '服务器请求超时',
          503: '服务器维护中，请稍后再试',
          504: '网关超时',
          505: 'HTTP版本不支持'
        };
        
        // 获取错误提示信息
        let errorMessage = data.msg || data.message || statusMessages[status] || `请求失败(${status})`;
        
        // 处理401未授权错误
        if (status === 401) {
          Toast.fail(errorMessage);
          // 清除登录信息
          localStorage.removeItem('rtc_token');
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          localStorage.removeItem('nickName');
          localStorage.removeItem('userName');
          localStorage.removeItem('phonenumber');
          localStorage.removeItem('isLogin');
          localStorage.removeItem('timeStamp');
          // 延迟跳转到登录页
          setTimeout(() => {
            router.push('/login');
          }, 1500);
        } else {
          // 其他错误统一显示中文提示
          Toast.fail(errorMessage);
        }
        
        return Promise.reject(err.response && err.response.data); // 返回接口返回的错误信息
      }
      
      // 网络错误或其他错误
      if (err.message) {
        let errorMessage = '网络连接失败，请检查网络设置';
        if (err.message.includes('timeout')) {
          errorMessage = '请求超时，请稍后重试';
        } else if (err.message.includes('Network Error')) {
          errorMessage = '网络连接失败，请检查网络设置';
        }
        Toast.fail(errorMessage);
      }
      
      return Promise.reject(err);
    }
  );
  return instance(config);
}
